import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-custom-tost',
  // templateUrl: './custom-tost.component.html',
  styleUrls: ['./custom-tost.component.scss'],
  template: `
  <div class="d-flex align-items-center">
  <img [src]="image" alt="image" class="mt-1 me-2" style="width:34px">

<div>
<span class="bold">{{ title }}</span>
  <div class="sub-text" >{{ text }}</div>
</div>

  </div>
`,
})
export class CustomTostComponent {
  @Input() text: string = '';
  @Input() image: string = '';
  @Input() title: string = '';
}
